import { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import {
  Stack,
} from '@mui/material';

// sections
import SearchPopover from '../../@header/SearchPopover';
import ApplicationPopover from '../../@header/ApplicationPopover';
import AccountPopover from '../../@header/AccountPopover';
import LanguagePopover from '../../@header/LanguagePopover';
import WebsitePopover from '../../@header/WebsitePopover';
import ToggleMode from '../../@header/ToggleMode';
import NotificationPopover from '../../@header/NotificationPopover';

// store

// _mock
import { NavSectionHorizontal } from '../../@header/navbar';
import { usePathname } from '../../../hooks/usePathname';

// ==============================|| Header Horizontal ||============================== //

HeaderHorizontal.propTypes = {
  onOpenNav: PropTypes.func,
  profile: PropTypes.object,
  application: PropTypes.object,
};

function HeaderHorizontal({ profile, existToken, navigations, applications }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const pathname = usePathname();

  return (
    <>
      <NavSectionHorizontal navConfig={navigations} />

      <Stack
        direction="row"
        alignItems="stretch"
        justifyContent={"stretch"}
        spacing={{ xs: 0, sm: 0 }}
        sx={{ minHeight: '100%' }}
      >

        { existToken && (<SearchPopover />) }

        <ApplicationPopover applications={applications} />

        { !existToken && (<LanguagePopover />) }

        { existToken && (<WebsitePopover />) }
        
        <ToggleMode sx={{ mr: 0.5 }} />

        { existToken && (<NotificationPopover />) }

        <AccountPopover existToken={existToken} />
        
      </Stack>
    </>
  );
}
export default memo(HeaderHorizontal)
